<template>
  <div class="showLogDialog-dialog">
    <el-dialog :visible.sync="visible" title="日志" class="ui6-bk-dialog" width="850px" @opened="opened" @closed="closed">
      <div class="table-box">
        <el-table :data="listData.records">
          <el-table-column property="id" label="ID" width="150"></el-table-column>
          <el-table-column property="createTime" label="操作时间" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | moment }}</span>
            </template>
          </el-table-column>
          <el-table-column property="depositDesc" label="操作详情" width="200"></el-table-column>
          <el-table-column property="createBy" label="操作人员"></el-table-column>
        </el-table>
      </div>
      <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          @current-change="queryList"
          :current-page="pagination.page"
          :page-size="pagination.size"
          :total="listData.total"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";
export default {
  name: "LockDialog",
  components: {},
  data() {
    return {
      visible: false,
      allowSub: true,
      contentText: {},
      rowInfo: {},
      pagination: { page: 1, size: 10 },
      listData: {}
    };
  },
  mounted() {},
  methods: {
    setInfo(info) {
      this.rowInfo = info;
    },
    setVisible(val) {
      this.visible = val;
    },

    queryList(e) {
      this.pagination.page = e;
      this.getListInfo();
    },
    getListInfo() {
      api
        .getListRecordV2({
          ...this.pagination,
          txId: this.rowInfo.id
        })
        .then(res => {
          this.listData = res.data;
        });
    },

    opened() {},
    closed() {}
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue === true) {
        this.getListInfo();
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
